import { useMemo } from 'react';

import type {
  InsightExplorerStatistics,
  InsightExplorerTrendResponse,
} from '../types/types';

type Props = {
  data?: InsightExplorerTrendResponse;
};

const useExplorerStatistics = (props: Props) => {
  const { data } = props;
  const statistics: InsightExplorerStatistics = useMemo(() => {
    return {
      totalVolume: data?.reduce((acc, curr) => acc + curr.volume.total, 0) || 0,
      negativeTotalVolume:
        data?.reduce((acc, curr) => acc + curr.negative_volume.total, 0) || 0,
    };
  }, [data]);

  return statistics;
};

export default useExplorerStatistics;
